<template>
    <div>
        <div class="search-bar">
            <div class="course-search">
                <el-input v-model.trim="searchvalue" size="small" placeholder="请输入内容"  @change="ToSearch"></el-input>
                <el-button type="primary" @click="ToSearch">搜索</el-button>
            </div>
        </div>

        <div class="course-list">
            <div class="course-card" v-for="(item,index) in courseList" :key="index" @click="ToDetail(item)">
                <div class="course-cover">
                    <img :src="item.goodsCover" alt="">
                </div>
                <div class="course-info">
                    <div class="title">{{item.courseName}}</div>
                    <div class="text"><img src="../../../assets/icon/course_icon2.png" alt="">
                        <div>{{item.className}}</div>
                    </div>
                    <div class="text"><img src="../../../assets/icon/course_icon1.png" alt="">
                        <div>{{item.teacherName}}</div>
                    </div>
                    <div class="text"><img src="../../../assets/icon/course_icon3.png" alt="">
                        <div>{{parseTime(item.createTime,'{y}-{m}-{d} {h}:{i}')}}</div>
                    </div>
                </div>
            </div>
        </div>
        <noData v-if="total == 0"></noData>

        <div class="pagination-box">
            <el-pagination
                class="ou-pagination"
                background
                hide-on-single-page
                @size-change="changePageSize"
                @current-change="changePageCurrent"
                :current-page="pageNum"
                :page-sizes="[5, 10, 15, 20]"
                :page-size="pageSize"
                layout="total, prev, pager, next, sizes, jumper, slot"
                :total="total"
            >
                <el-button @click="getCurrentTabList" class="ou-page-go">GO</el-button>
            </el-pagination>
        </div>

    </div>
</template>
<script>
import noData from "@/components/noData.vue";
import pages from "@/components/pages.vue";
import { GetCourseList } from '@/api/user/course'
export default{
    components: { noData, pages },
    data(){
        return{
            pageNum: 1,
            pageSize: 10,
            courseList: [],
            total: 0,
            searchvalue:''
        }
    },
    created(){
        this.getList()
    },
    methods:{
        //切换页尺寸
        changePageSize(val) {
        this.pageSize = val;
        },
        changePageCurrent(val) {
        this.pageNum = val;

        }, 
        getCurrentTabList(){

        },

        ToDetail(item){
            this.$router.push({
                path:'/course/detail',
                query:item
            })
        },

        //获取列表
        getList(){
            GetCourseList({
                pageNum:this.pageNum,
                pageSize:this.pageSize,
                name:this.searchvalue
            }).then(res=>{
                console.log(res);
                this.total = res.total
                this.courseList = res.rows
            })
        },

        ToSearch(){
            this.pageNum = 1
            this.getList()
        }
    }
}
</script>
<style scoped lang='scss'>
    .search-bar{
        padding: 11px 20px;
        box-sizing: border-box;
        border-bottom: 1px solid #F2F1EF;
        display: flex;
        align-items: center;
        justify-content: flex-end;

        .course-search{
            display: flex;
            align-items: center;

            .el-input{
                margin-right: -4px;
                margin-top: -2px;
                height: 30px;


                &__inner{
                    height: 100% !important;
                }
               
            }

            .el-button{
                z-index: 9;
                height: 32px;
                line-height: 30px;
                padding: 0 20px;
            }
        }
    }

    .course-list{
        padding: 20px;
        box-sizing: border-box;
        display: grid;
        align-items: center;
        grid-row-gap: 24px;
        grid-column-gap: 24px;
        justify-content: start;
        grid-template-columns: repeat(auto-fit, 330px);


        .course-card{
            width: 100%;
            height: 144px;
            background: #FFFFFF;
            box-shadow: 0px 1px 5px 0px rgba(0,0,0,0.1);
            border-radius: 6px 6px 6px 6px;
            cursor: pointer;
            display: flex;
            align-items: flex-start;
            justify-content: space-between;
            padding: 10px;
            box-sizing: border-box;

            .course-cover{
                width: 124px;
                height: 124px;
                border-radius: 6px;
                overflow: hidden;

                img{
                    width: 100%;
                    height: 100%;
                }
            }

            .course-info{
                width: calc(100% - 140px);

                .title{
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 500;
                    font-size: 16px;
                    color: #000000;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }

                .text{
                    display: flex;
                    align-items: center;
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 400;
                    font-size: 14px;
                    color: #666666;
                    margin-top: 13px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;

                    img{
                        width: 18px;
                        height: 18px;
                        margin-right: 5px;
                    }

                    >div{
                        white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;

                    }
                }
            }
        }
    }

    .pagination-box {
    padding: 24px 30px;
    text-align: right;
  }
</style>